<template>
  <div class="template-benefits" data-testid="template-benefits">
    <Heading class="template-benefits__title" :level="2">{{ title }}</Heading>
    <Row
      v-for="(row, index) in data.rows"
      :key="index"
      :left-title="row.title"
      :left-subtitle="row.description"
      :has-line="index !== 0"
    >
      <template #icon-left>
        <InitialAvatarIcon :icon="row.icon" size="small" />
      </template>
    </Row>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Row, Heading, InitialAvatarIcon } from '@warrenbrasil/nebraska-web';

import { ITemplateBenefitsData } from './types';

interface Props {
  data: ITemplateBenefitsData;
}
const props = defineProps<Props>();

const title = computed(() => {
  return props.data?.title || '-';
});
</script>

<style lang="less" scoped>
.template-benefits {
  padding: 0 @size-spacing-x400;
  margin: 0 auto;
  max-width: 832px;

  &__title {
    margin-bottom: @size-spacing-x500;
  }
}
</style>
